module.exports = {
    videosData: () => {
        return [{
            "Nombre": "Casa Ambar",
            "Imagen": require("./videos/casaAmbar.png"),
            "Link": "https://www.youtube.com/embed/ZPXWZYJdpbk",
        }]
    }
}